export default __webpack_public_path__ + "static/media/287.0022d448.gif";